import { UserBusinessFeatures } from '../entity/business-features.entity';
export class SGMarket implements UserBusinessFeatures {
  getUserAddressFeatures() {
    return {
      showApartmentBeforeStreet: false,
    };
  }
}
